/** 필수값·저장 실패 등 사용자 액션 피드백용 알림창 */
export function notifyError(message: string) {
  const text = message?.trim();
  if (!text) return;
  window.alert(text);
}

export function notifyInfo(message: string) {
  const text = message?.trim();
  if (!text) return;
  window.alert(text);
}

/** 화면 상단 메시지 + 알람창을 함께 표시 */
export function reportError(setError: (message: string) => void, message: string) {
  const text = message?.trim();
  if (!text) return;
  setError(text);
  window.alert(text);
}
